module.exports = __webpack_public_path__ + "img/lock.8f301b48.png";